import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import Button from "../Reusable/Button";
import ComboboxInput from "../Reusable/ComboboxInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import TextField from "../Reusable/TextInput";
const ChangeStatus = (props: any) => {
  const { selectedId, setOpenStatusChangePopup } = props;

  const { refetch } = useGetHook({
    queryKey: [`ticket-${selectedId}`],
    url: `${APIS.TICKET}${selectedId}/`,
    params: {},
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
    watch,
  } = useForm<any>({
    defaultValues: async () => {
      let data: any = await refetch();
      return {
        ...data?.data,
      };
    },
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["ticket"],
    navigateURL: "",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.TICKET}${selectedId}/`;
    let formData = {
      resolution: values?.resolution,
      status: values?.status,
      extra_data: values?.extra_data,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res.status === 200) {
        setOpenStatusChangePopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const extraField = watch("extra_data");

  return (
    <form
      onSubmit={handleSubmit((data: any) => handleEdit(data, setError))}
      autoComplete="off"
      className={tw`px-4`}
    >
      <ComboboxInput
        url={`${APIS.TICKET}available-status/`}
        queryKey={"status"}
        register={register("status", { required: "Status is required" })}
        errors={errors?.parent}
        name={"status"}
        label={"Status"}
        setValue={setValue}
        placeholder={"Search Status"}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      {Array.isArray(extraField) && extraField?.length > 0
        ? extraField?.map((item: any, index: number) => {
            return item?.type === "text" ? (
              <TextField
                key={item?.label}
                register={register(
                  `extra_data.${[index]}.value`,
                  item?.required
                    ? {
                        required: `${item?.label} is required`,
                      }
                    : {}
                )}
                //@ts-ignore
                errors={errors?.extra_data?.[index]?.value}
                label={item?.label}
              />
            ) : (
              <div key={item?.label} className={tw`w-full my-2 text-left mt-4`}>
                <label htmlFor={item?.label} className={tw`capitalize`}>
                  {item?.label}
                </label>
                <input
                  type="text"
                  id={item?.label}
                  {...register(
                    `extra_data.${[index]}.value`,
                    item?.required
                      ? {
                          required: `${item?.label} is required`,
                        }
                      : {}
                  )}
                  maxLength={255}
                  className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
                />
                {errors?.extra_data?.[index]?.value && (
                  <p className={tw`text-red-500 text-xs my-1`}>
                    {errors?.extra_data?.[index]?.value?.message}
                  </p>
                )}
              </div>
            );
          })
        : null}
      <div className={tw`mt-2`}>
        <label htmlFor="resolution">Conclusion</label>
        <textarea
          id="resolution"
          rows={6}
          {...register("resolution", { required: "Conclusion is required" })}
          className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
          placeholder="Write a conclusion..."
        ></textarea>
        {errors?.resolution && (
          <p className={tw`text-red-500 text-xs my-1`}>
            {errors?.resolution?.message}
          </p>
        )}
      </div>
      <div className={tw`flex justify-end w-full`}>
        <div className={tw`w-[150px] `}>
          <Button label={"Update"} isLoading={isPatchLoading} />
        </div>
      </div>
    </form>
  );
};

export default ChangeStatus;
